import React, { useEffect, useState } from "react";
import { useMatch, useNavigate } from "react-router-dom";
import { useIsAdmin } from "../../../auth/authUtils";

import ErrorMessage from "../../../components/alert/ErrorMessage";
import UploadMediaDialog from "./UploadMediaDialog";

const UploadMedia = () => {
  const match = useMatch("/creator/upload");
  const navigate = useNavigate();
  const isAdmin = useIsAdmin();

  const [open, setOpen] = useState(false);
  const handleCancel = () => navigate(-1);

  useEffect(() => {
    if (match) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [match]);

  return (
    <div id="upload-media-root">
      {isAdmin ? (
        <ErrorMessage
          display="flex"
          justifyContent="center"
          alignItems="center"
          bgcolor="white"
          height="calc(100vh - 200px)"
          borderRadius={20}
          error={{
            message:
              "Sorry! Must be logged into an organization to upload media",
          }}
        />
      ) : (
        <UploadMediaDialog visible={open} onCancel={handleCancel} />
      )}
    </div>
  );
};

export default UploadMedia;
